import React from "react";
import { getImage } from "../../helpers";
import { useState } from "react";
import { useEffect } from "react";
import { formatHumansBs } from "../../helpers/formatHuman";
const ResumentCompra = () => {
    const [carritoLocal, setCarritoLocal] = useState([]);
    const [subTotal, setSubTotal] = useState(0);

    useEffect(() => {
        const localCarrito =
            JSON.parse(localStorage.getItem("CarritoJucumari")) ?? [];
        setCarritoLocal(localCarrito);
        if (localCarrito.length > 0) {
            let subTotal = localCarrito.reduce(
                (total, producto) =>
                    total + producto.precio * producto.cantidad,
                0
            );
            setSubTotal(subTotal);
        }
    }, []);
    return (
        <div className="bg-white px-2">
            <h1 className="text-xl font-bold">Resumen de la compra</h1>
            <ul className="list-none">
                {carritoLocal.map((item, index) => (
                    <li
                        key={index}
                        className={`flex items-center gap-2 py-2 ${
                            index !== carritoLocal.length - 1
                                ? "border-b border-gray-200"
                                : ""
                        }`}
                    >
                        <span className="h-4 w-4 p-3 flex justify-center items-center text-center text-xs font-semibold rounded-full text-white bg-tertiary-personalize/50">
                            {item.cantidad}
                        </span>
                        <img
                            src={getImage(item.imagen)}
                            alt="Propiedad imagen"
                            className="object-cover h-auto w-10"
                        />
                        <div className="flex flex-col flex-1">
                            <p className="text-sm lg:text-base text-end text-gray-400 font-semibold">
                                {item.nombrep}
                            </p>
                            <p className="text-gray-600 text-md text-end font-bold">
                                {formatHumansBs(item.precio)}
                            </p>
                        </div>
                        
                    </li>
                ))}
            </ul>
            <p className="text-lg font-semibold border-t border-t-gray-400 flex items-center justify-between">
                Total: {" "}
                <span className=" font-bold text-tertiary-personalize">{ formatHumansBs(subTotal) }</span>
            </p>
        </div>
    );
};

export default ResumentCompra;
